import React from "react";
import {
  Card,
  Container,
  Row,
  Col,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import DataTable from "react-data-table-component";
import { useSelector, useDispatch } from "react-redux";
import { EnforcementActions, SuperAdminAction } from "../../Actions";
import DatatableHeader from "../DatatableHeader/DatatableHeader";
import { isEmpty } from "lodash";
import {
  findBySearch,
  scroolToTop,
  tableHeightScrollBars,
  utcToSpecificTimeZone,
} from "../helper";
import t from "../../Actions/EnforcementActions/types";
import Loader from "../Loader/Loader";
import NoImage from "../../../assets/img/No-Image.svg";
import { SRLWrapper } from "simple-react-lightbox";
import defaultImage from "../../../assets/img/no_image_available.svg";

const AuditReport = () => {
  const dispatch = useDispatch();
  const [searchValue, setSearchValue] = React.useState("");
  const [filtered, setFiltered] = React.useState("");
  const [finalTableHeight, setFinalTableHeight] = React.useState(0);
  const auditReport = useSelector(
    // to get audit report from reducer
    (state) => state.EnforcementDetails.auditReportList
  );
  const getPropertyData = useSelector(
    // to get audit report from reducer
    (state) => state.UserProfileDetails.property
  );

  const main_body = useSelector((state) => state.Logindetails.MainBackground);
  const loader = useSelector((state) => state.EnforcementDetails.loader);
  const timeZone = useSelector((state) => state.UserProfileDetails.timezone);

  const customStyles = React.useRef({
    rows: {
      style: {
        minHeight: "72px",
      },
    },
    headCells: {
      style: {
        paddingLeft: "8px",
        paddingRight: "8px",
      },
    },
    cells: {
      style: {
        paddingLeft: "8px",
        paddingRight: "8px",
      },
    },
  });
  const options = {
    buttons: {
      showAutoplayButton: false,
      showCloseButton: true,
      showDownloadButton: false,
      showFullscreenButton: false,
      showNextButton: true,
      showPrevButton: true,
      showThumbnailsButton: false,
    },
    ProgressBar: {
      showProgressBar: false,
    },
    thumbnails: {
      showThumbnails: false,
    },
  };

  const columns = React.useRef([]);

  const handleSearchChange = (e) => {
    setSearchValue(e.target.value);
    !isEmpty(e.target.value) && search(e.target.value);
  };
  const search = (val) => {
    const columnList = ["created_at", "full_name", "lpn", "lot_name", "result"];
    const filteredValue = findBySearch(
      val,
      auditReport,
      auditReport,
      columnList,
      timeZone
    );
    setFiltered([...filteredValue]);
  };

  React.useEffect(() => {
    if (auditReport && !isEmpty(auditReport)) {
      setFiltered([...auditReport]);
    }
  }, [auditReport]);

  React.useEffect(() => {
    const selectedPropertyName = getPropertyData?.property_name;
    const selectedDomainName = getPropertyData?.domain;
    dispatch(
      SuperAdminAction.setDomainHeader(selectedPropertyName, selectedDomainName)
    );
  }, [dispatch]);

  React.useEffect(() => {
    if (filtered && filtered.length) {
      const height = tableHeightScrollBars();
      setFinalTableHeight(height);
    }
  }, [filtered]);

  const checkLpn = (lpn) => {
    const history = require("../../history").default;
    history.push({
      pathname: `/current-occupancy`,
      search: "audit-report",
      state: {
        lpn: lpn,
      },
    });
  };

  const redirectToTicket = (row) => {
    const history = require("../../history").default;
    history.push({
      pathname: "/citation",
      state: {
        lpn: row.lpn,
        image: row.scan_plate_image ? row.scan_plate_image : "",
      },
    });
  };

  const ShowCell = React.useCallback((row, _, column) => {
    let data = "";
    switch (column.name) {
      case "Date Time":
        data = row.created_at
          ? utcToSpecificTimeZone(timeZone, row.created_at)
          : "-";
        break;
      case "User":
        data =
          row && row.users && row.users.first_name && row.users.last_name
            ? `${row.users.first_name} ${row.users.last_name}`
            : "";
        break;
      case "LPN":
        data =
          row && row.lpn ? (
            <div className="curserPointer" onClick={() => checkLpn(row.lpn)}>
              {row.lpn}
            </div>
          ) : (
            ""
          );
        break;
      case "LOT":
        data = (
          <OverlayTrigger
            delay={{ show: 250, hide: 400 }}
            placement={"top"}
            overlay={<Tooltip id={`tooltip-qw`}>{row?.lots?.alias}</Tooltip>}
          >
            <div className="text-nowrap text-truncate pr-3">
              {row?.lots?.alias ? row.lots.alias : "-"}
            </div>
          </OverlayTrigger>
        );
        break;
      case "Result":
        if (row && row.result && row.result.toLowerCase() === "not approved") {
          return (
            <div
              onClick={() => redirectToTicket(row)}
              className="curserPointer"
            >
              <Rejected />
              <span className={"ml-2"}>{row.result}</span>
            </div>
          );
        } else if (
          row &&
          row.result &&
          row.result.toLowerCase() === "approved"
        ) {
          return (
            <div
              onClick={() => redirectToTicket(row)}
              className="curserPointer"
            >
              <Approved />
              <span className={"ml-2"}>{row.result}</span>
            </div>
          );
        } else if (
          row &&
          row.result &&
          row.result.toLowerCase() === "unknown"
        ) {
          return (
            <div
              onClick={() => redirectToTicket(row)}
              className="curserPointer"
            >
              <Unknown />
              <span className={"ml-2"}>{row.result}</span>
            </div>
          );
        }
        break;
      case "Image":
        if (row) {
          const dateZone = row.created_at
            ? utcToSpecificTimeZone(timeZone, row.created_at)
            : "-";
          const alt = `${row.lpn}| ${dateZone}`;
          const image = row.scan_plate_image ? row.scan_plate_image : NoImage;
          const defImage = row.scan_plate_image
            ? row.scan_plate_image
            : defaultImage;
          data = (
            <a href={defImage}>
              <img
                style={{ height: "30px", width: "65px" }}
                className="img-fluid no-image-available"
                src={image}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = NoImage;
                }}
                alt={alt}
              />
            </a>
          );
        }
        //  else {
        //   data = <>{"N/A"}</>;
        // }

        break;
      default:
        break;
    }
    return <CellDisplay data={data} />;
  }, []);

  React.useEffect(() => {
    const init = async () => {
      dispatch(EnforcementActions.getAuditReoprts());
      dispatch({
        type: t.SHOW_HIDE_LOADER,
        payload: true,
      });
      columns.current = [
        {
          name: "Date Time",
          sortable: true,
          minWidth: "140px",
          cell: ShowCell,
          selector: (row) => row.created_at,
        },
        {
          name: "User",
          sortable: true,
          minWidth: "180px",
          cell: ShowCell,
          selector: (row) => row.user,
        },
        {
          name: "LPN",
          sortable: true,
          cell: ShowCell,
          selector: (row) => row.lpn,
        },
        {
          name: "LOT",
          sortable: true,
          cell: ShowCell,
          selector: (row) => row.lot_id,
        },
        {
          name: "Result",
          sortable: true,
          minWidth: "140px",
          cell: ShowCell,
          selector: (row) => row.result,
        },
        {
          name: "Image",
          sortable: true,
          cell: ShowCell,
          selector: (row) => row.scan_plate_image,
        },
      ];
    };
    init();
  }, []);

  const hideSlider = () => {
    document.body.classList.remove("foc-open");
  };

  const getPaginationRows = (searchData, report, filter) => {
    let pageLength = report.length;
    if (searchData && searchData.length) {
      pageLength = filter.length;
    }
    return pageLength;
  };

  const getTableData = (searchValueData, reportData, filterValue) => {
    let data = reportData;
    if (searchValueData && searchValueData.length) {
      data = filterValue;
    }
    return data;
  };

  return (
    <div>
      <Container fluid className="manage-unit-list-page page-no-fliter">
        <Row>
          <Col md="12">
            <Card className="mb-0">
              <Card.Body className="pos-rel-overflow-hide">
                <>
                  <div className="sidebarFilter">
                    <Card className="contact-container mb-0">
                      <Card.Header style={{ backgroundColor: main_body }}>
                        <div className="d-flex align-items-center justify-content-between">
                          <Card.Title as="h4">List of Audit Report</Card.Title>
                          <a
                            onClick={hideSlider}
                            href="javascript:void(0);"
                            className="btn btn-sm border-0 bg-light rounded-circle  w-30px h-30px d-flex align-items-center justify-content-center"
                          >
                            <i className="fa fa-times" aria-hidden="true"></i>
                          </a>
                        </div>
                      </Card.Header>
                      <Card.Body></Card.Body>
                      <Card.Footer className="text-right justify-content-between d-flex"></Card.Footer>
                    </Card>
                  </div>
                  <header>
                    <div className="active-permit-header sm-flex-column sm-align-items-start">
                      <h5 className="mb-2 mb-md-0">List of Audit Report</h5>
                      <div className="filter-button d-flex flex-wrap">
                        <div className="d-flex align-items-center search-mb-0">
                          <DatatableHeader
                            className="mt-0 mb-0"
                            // Header={"List of Units"}
                            searchValue={searchValue}
                            HandleChange={handleSearchChange}
                          />
                        </div>
                      </div>
                    </div>
                  </header>
                </>
                {!auditReport?.length && !filtered?.length && !loader && (
                  <span className="text-center d-block">{`There are no records to display`}</span>
                )}
                {loader ? (
                  <Loader />
                ) : (
                  <>
                    {filtered && (
                      <>
                        <SRLWrapper options={options}>
                          <div className="citation-list-table verify-audit-table">
                            <DataTable
                              data={getTableData(
                                searchValue,
                                auditReport,
                                filtered
                              )}
                              columns={columns.current}
                              customStyles={customStyles.current}
                              responsive={true}
                              defaultSortAsc={true}
                              fixedHeader={true}
                              onChangePage={scroolToTop}
                              fixedHeaderScrollHeight={finalTableHeight}
                              paginationPerPage="100"
                              paginationTotalRows={getPaginationRows(
                                searchValue,
                                auditReport,
                                filtered
                              )}
                              pagination={true}
                              paginationRowsPerPageOptions={[
                                100, 200, 300, 400,
                              ]}
                            />
                          </div>
                        </SRLWrapper>
                      </>
                    )}
                  </>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AuditReport;
const CellDisplay = ({ data }) => {
  return <div>{data}</div>;
};
export const Rejected = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.3 11.109C24.3 11.7186 24.3 12.3283 24.3 12.9379C24.211 13.1583 24.225 13.3927 24.1922 13.6178C23.8454 16.0328 22.8797 18.1618 21.2485 19.9766C19.3219 22.1196 16.9313 23.4232 14.0813 23.8687C13.786 23.9156 13.4813 23.9015 13.1907 24C12.5813 24 11.9719 24 11.3625 24C11.3204 23.9297 11.25 23.9578 11.1938 23.9531C10.7344 23.9062 10.2797 23.8406 9.82974 23.7468C7.53755 23.2544 5.55005 22.1899 3.8813 20.5393C1.99224 18.6682 0.843799 16.4174 0.431299 13.7819C0.389111 13.5006 0.398486 13.2098 0.300049 12.9379C0.300049 12.2954 0.300049 11.6577 0.300049 11.0152C0.412549 10.7057 0.398486 10.3775 0.450049 10.0586C0.876611 7.58734 1.94536 5.44431 3.69849 3.6483C5.57817 1.72098 7.85161 0.548651 10.5188 0.131301C10.8 0.0890967 11.0907 0.098476 11.3625 0C11.9719 0 12.5813 0 13.1907 0C13.2188 0.056272 13.2704 0.0422051 13.3125 0.0422051C15.1547 0.192264 16.8797 0.731535 18.4454 1.70223C21.6375 3.68112 23.5547 6.52286 24.1641 10.2415C24.2204 10.5322 24.2063 10.8277 24.3 11.109ZM8.57349 7.29191C8.40474 7.2966 8.2313 7.3388 8.07661 7.43728C7.50942 7.78898 7.42974 8.53458 7.92192 9.02696C8.85005 9.96483 9.78286 10.898 10.725 11.8265C10.8797 11.9766 10.861 12.0516 10.7204 12.1876C10.2188 12.6706 9.73599 13.1676 9.2438 13.66C8.79849 14.1055 8.34849 14.551 7.90317 15.0012C7.60317 15.3107 7.5188 15.6811 7.67349 16.0797C7.82817 16.4736 8.13286 16.6846 8.55474 16.7081C8.88755 16.7315 9.15474 16.5815 9.38442 16.347C10.3079 15.4185 11.2407 14.49 12.1641 13.5615C12.2766 13.449 12.3422 13.4349 12.4594 13.5569C12.9563 14.068 13.4625 14.5651 13.9641 15.0668C14.4188 15.5217 14.8641 15.9766 15.3235 16.422C15.6516 16.7409 16.125 16.7972 16.5141 16.5815C16.8844 16.3798 17.0766 15.9625 17.0063 15.5264C16.9641 15.2732 16.8235 15.0856 16.6454 14.9121C15.7313 14.0023 14.8266 13.0832 13.9079 12.1829C13.7485 12.0281 13.7672 11.9437 13.9172 11.803C14.3579 11.381 14.7797 10.9449 15.211 10.5135C15.7125 10.0117 16.2235 9.51465 16.7157 9.00352C17.1516 8.55334 17.1188 7.89215 16.6594 7.51231C16.2563 7.17468 15.6844 7.21219 15.2813 7.61078C14.3438 8.53927 13.411 9.47245 12.4829 10.415C12.3469 10.5557 12.2766 10.5557 12.1407 10.415C11.2266 9.48652 10.2985 8.56741 9.37974 7.64361C9.15474 7.4279 8.9063 7.29191 8.57349 7.29191Z"
        fill="#F34336"
      />
    </svg>
  );
};

export const Unknown = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="12" fill="#25B8D3" />
      <path
        d="M12.2463 4.15625C13.3479 4.15985 14.4003 4.37105 15.3471 4.95665C16.7403 5.81885 17.4519 7.06445 17.3367 8.71865C17.2671 9.72005 16.7325 10.5037 16.0233 11.1757C15.3717 11.7925 14.7021 12.3895 14.0493 13.0045C13.5855 13.4413 13.2945 13.9537 13.1757 14.5741C13.1367 14.7781 13.0893 14.9833 13.0233 15.1801C12.8421 15.7165 12.4329 15.9799 11.8239 15.9685C11.2605 15.9577 10.7841 15.6331 10.6569 15.1177C10.4415 14.2435 10.6221 13.4166 11.0367 12.6342C11.3463 12.0498 11.8305 11.6125 12.3045 11.1673C12.8511 10.6543 13.4469 10.1916 13.9437 9.62765C14.6715 8.80265 14.6463 7.77545 13.8945 7.00265C13.5831 6.68285 13.1943 6.49925 12.7593 6.41585C12.3597 6.33965 11.9613 6.36665 11.5605 6.42785C10.7511 6.55085 10.3083 7.10045 9.96512 7.77245C9.77852 8.13845 9.65312 8.52845 9.50432 8.90945C9.20132 9.68525 8.55152 10.0183 7.80392 9.78845C7.24712 9.61685 6.83552 9.05705 6.85412 8.47445C6.88472 7.50305 7.28012 6.67325 7.91672 5.96585C8.98232 4.78205 10.3377 4.21445 11.9223 4.17245C12.0303 4.17005 12.1383 4.16225 12.2463 4.15625Z"
        fill="white"
      />
      <path
        d="M11.971 20.069C11.0578 20.0744 10.3906 19.4276 10.381 18.5282C10.3714 17.6378 11.0584 16.9454 11.959 16.9376C12.8404 16.9304 13.5376 17.6204 13.5376 18.5012C13.5382 19.3988 12.8734 20.0642 11.971 20.069Z"
        fill="#FEFFFF"
      />
    </svg>
  );
};

export const Approved = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.9946 11.0623C24.9946 11.6887 24.9946 12.3151 24.9946 12.9352C24.9383 12.9603 24.9508 13.0104 24.9508 13.0542C24.9132 13.5115 24.8443 13.9688 24.7566 14.4198C23.3913 21.1285 16.6085 25.3442 9.95726 23.6091C3.80077 22.0055 -0.0509543 15.7916 1.24548 9.56516C2.26634 4.63538 6.24332 0.889491 11.2474 0.12528C11.5167 0.0814323 11.7986 0.100224 12.0616 0C12.6691 0 13.2829 0 13.8904 0C13.9029 0.0501122 13.9468 0.0438481 13.9843 0.0438481C15.7505 0.181657 17.4164 0.676514 18.9383 1.57853C22.2577 3.54544 24.2431 6.43315 24.8694 10.2479C24.9132 10.5173 24.8944 10.7992 24.9946 11.0623ZM21.2995 8.18081C21.2744 7.60452 20.9738 7.09714 20.36 6.82778C19.7212 6.5459 19.12 6.64613 18.6001 7.12219C17.6607 7.98036 16.7338 8.85106 15.8006 9.72176C14.1347 11.2752 12.4562 12.8412 10.7902 14.4072C10.6337 14.5513 10.5585 14.5764 10.4019 14.401C9.36854 13.2735 8.31636 12.1585 7.27045 11.0372C6.88841 10.63 6.43121 10.4108 5.87381 10.4672C5.2162 10.5361 4.75274 10.8931 4.52727 11.5133C4.3018 12.1459 4.45212 12.7097 4.90305 13.1983C6.68799 15.1088 8.4792 17.0193 10.2579 18.9361C10.3894 19.0739 10.452 19.0865 10.5961 18.9487C12.0992 17.5393 13.6148 16.1361 15.1179 14.733C16.9906 12.9853 18.8632 11.2314 20.7358 9.48373C21.1053 9.16426 21.2995 8.76337 21.2995 8.18081Z"
        fill="#00B900"
      />
    </svg>
  );
};
